import decodeJWT from 'jwt-decode'

export function getUserName (token) {
  return decodeJWT(token).user_name
}



// WEBPACK FOOTER //
// ./src/helpers/decode-username.js